import React, { useRef } from 'react';
import { useCollectionItemQuery } from '@annunciate/query';
import { DisplayMode } from '@annunciate/core';
import { CellContainer } from '@shopify/flash-list';
import { COLLECTION_ITEMS } from '../../../utils/mocks';
import { CarouselItem } from './CarouselItem';
import { View, useTheme } from '../../..';
import { CollectionHero } from './CollectionHero';
import { FlashList } from '../../shared';
export const Carousel = ({ collection }) => {
    const { isFetchingNextPage, isFetchingPreviousPage, hasNextPage, data, fetchNextPage, } = useCollectionItemQuery({
        parentId: collection.id,
        displayMode: DisplayMode.CAROUSEL,
        shouldObserveUser: collection.isUserDependent,
    });
    const { defaultCardHeight } = useTheme();
    const scrollMap = useRef({});
    const isHeroDisplayed = collection?.displayConfig?.displayHero;
    const isLoadingPage = isFetchingNextPage || isFetchingPreviousPage;
    const isLoading = data.length == 0;
    let item = data;
    if (isLoading) {
        item = COLLECTION_ITEMS;
    }
    else if (isLoadingPage) {
        item = [
            ...data,
            COLLECTION_ITEMS[1],
        ];
    }
    const renderItem = (props) => (React.createElement(CarouselItem, { index: props.index, item: props.item, scrollMap: props.extraData?.current }));
    return (React.createElement(FlashList, { data: item, keyExtractor: (item, idx) => {
            if (item.id < 0) {
                return `${item.id}-${collection.id}-${idx}`;
            }
            return `${item.id}`;
        }, extraData: scrollMap, renderItem: renderItem, drawDistance: defaultCardHeight + 30, onEndReached: () => { if (hasNextPage)
            fetchNextPage(); }, onEndReachedThreshold: 0.5, estimatedItemSize: defaultCardHeight + 30, getItemType: (item) => item.__typename, ListHeaderComponent: isHeroDisplayed === true ? (React.createElement(View, null, collection.cover && (React.createElement(CollectionHero, { uri: collection.cover.src, collection: collection })))) : undefined, CellRendererComponent: (props) => (React.createElement(CellContainer, { ...props, style: [props.style, { zIndex: props.index }] })) }));
};
//# sourceMappingURL=Carousel.js.map